<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      d="M11.667 7.795a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      fill="currentColor" /><path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.566 2.422a3.147 3.147 0 0 1 3.622.334l.659.564a8.533 8.533 0 0 1 1.64 0l.658-.563a3.147 3.147 0 0 1 3.62-.334l.468.271a3.15 3.15 0 0 1 1.52 3.302l-.158.854a7.61 7.61 0 0 1 .819 1.417l.82.29a3.148 3.148 0 0 1 2.098 2.968v.54a3.149 3.149 0 0 1-2.102 2.969l-.817.288a8.487 8.487 0 0 1-.82 1.418l.159.854a3.147 3.147 0 0 1-1.52 3.302l-.467.27a3.147 3.147 0 0 1-3.621-.332l-.66-.567a8.526 8.526 0 0 1-1.638.001l-.659.564a3.147 3.147 0 0 1-3.62.334l-.468-.27a3.15 3.15 0 0 1-1.52-3.304l.16-.854a7.613 7.613 0 0 1-.818-1.416l-.82-.29A3.149 3.149 0 0 1 1 12.065v-.54a3.15 3.15 0 0 1 2.1-2.969l.817-.287c.226-.496.5-.972.82-1.42l-.159-.852a3.147 3.147 0 0 1 1.52-3.303l.468-.27Zm2.322 1.854c-.37-.317-.9-.365-1.32-.122l-.47.271c-.42.242-.643.725-.554 1.204l.24 1.287a1 1 0 0 1-.203.808 6.496 6.496 0 0 0-.984 1.703 1 1 0 0 1-.599.58l-1.232.435A1.148 1.148 0 0 0 3 11.524v.54c0 .487.307.92.766 1.082l1.239.438a1 1 0 0 1 .599.579c.124.317.258.612.417.887.162.28.351.545.564.813a1 1 0 0 1 .2.806l-.241 1.29c-.089.479.134.961.555 1.204l.468.271c.422.243.95.194 1.32-.122l.993-.85a1 1 0 0 1 .803-.229c.643.099 1.306.1 1.966 0a1 1 0 0 1 .8.229l.994.851c.37.317.9.366 1.32.123l.468-.271c.422-.244.644-.726.555-1.204l-.24-1.288a1 1 0 0 1 .202-.808 6.482 6.482 0 0 0 .983-1.701c.106-.272.326-.484.601-.581l1.232-.436c.459-.162.767-.595.767-1.082v-.54c0-.486-.308-.92-.767-1.082-.03-.013-1.712-.703-1.834-1.017a6.575 6.575 0 0 0-.42-.891 6.476 6.476 0 0 0-.561-.807 1 1 0 0 1-.201-.807l.24-1.29a1.148 1.148 0 0 0-.555-1.205l-.468-.271a1.148 1.148 0 0 0-1.32.122l-.994.85a1 1 0 0 1-.802.228 6.538 6.538 0 0 0-1.97 0 1 1 0 0 1-.8-.228l-.991-.851Z"
      fill="currentColor" />
  </g>
</svg>
